import React from "react";
import { NavLink } from "react-router-dom";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Column 1: Company */}
        <div className="footer-column">
          <h4 className="footer-heading">Company</h4>
          <NavLink to="/about" className="footer-link">About Us</NavLink>
          <NavLink to="/tours" className="footer-link">Tours</NavLink>
          <NavLink to="/services" className="footer-link">Services</NavLink>
        </div>

        {/* Column 2: Travel Services */}
        <div className="footer-column">
          <h4 className="footer-heading">Travel Services</h4>
          <NavLink to="/mice" className="footer-link">MICE</NavLink>
          <NavLink to="/visa" className="footer-link">Visa Assistance</NavLink>
          <NavLink to="/hotels" className="footer-link">Hotel Booking</NavLink>
          <NavLink to="/flights" className="footer-link">Flight Booking</NavLink>
        </div>

        {/* Column 3: Contact */}
        <div className="footer-column">
          <h4 className="footer-heading">Contact Us</h4>
          
          {/* Phones and Social Links */}
          <div className="footer-contact-phones">
            {/* WhatsApp */}
            <a
              href="https://wa.me/919096785868?text=Hi!%20I'd%20like%20to%20know%20more%20about%20your%20travel%20packages."
              target="_blank"
              rel="noopener noreferrer"
              className="footer-link whatsapp-link"
            >
              <img 
                src="/assets/images/whatsapp.png" 
                alt="WhatsApp" 
                className="whatsapp-icon-img" 
              />
              +91-9096785868
            </a>

            {/* Phone 2 */}
            <a href="tel:+919175785868" className="footer-link">
              📞 +91-9175785868
            </a>

            {/* Phone 3 */}
            <a href="tel:+919146785868" className="footer-link">
              📞 +91-9146785868
            </a>

            {/* NEW: Simple Instagram Link (Like Contact Page) */}
            <a 
              href="https://www.instagram.com/roamtheworldofficial" 
              target="_blank" 
              rel="noopener noreferrer"
              className="footer-link"
            >
              <img 
                src="/assets/images/instalogo.avif" 
                alt="Instagram" 
                style={{ width: '20px', height: '20px', objectFit: 'contain' }} 
              />
              @roamtheworldofficial
            </a>
          </div>

          {/* Email */}
          <a href="mailto:roamtheworld.ngp@gmail.com" className="footer-link">
            ✉️ roamtheworld.ngp@gmail.com
          </a>
          
          {/* Address */}
          <p className="footer-text">
            🏢 Add:- Shop No 04A, NKY Tower Building First Floor <br />
                Near Ajni Metro station Nagpur - 440015
          </p>
        </div>
      </div>

      {/* Copyright Section */}
      <div className="footer-bottom">
        <p className="copyright">© 2026 Roam The World. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;